<!--支持对比的探头历史-->
<template>
  <div
    class="uk-flex uk-flex-column h-100 pd-5 border-box"
    style="overflow: hidden;"
  >
    <FullPath :carrierId="carrierInfo.id" @onFullPath="onFullPath"></FullPath>
    <div class="uk-flex uk-flex-1 h-100">
      <ProbeInfo
        :carrier-info="carrierInfo"
        :time-range="timeRange"
        :min-max="minMax"
        :customUnit ="customUnit"
        @probeChange="probeChange"
        @otherProbeChange="otherProbeChange"
        @showBuffer="showBuffer"
        ref="probeInfo"
      ></ProbeInfo>
      <!-- 右侧统计 -->
      <div class="border ml-5  pd-10 h-100" style="width: calc(100% - 200px)">
        <div class="bolder font-16 mb-5">{{ currentProbe.name }}</div>
        <!-- <HistoryChart></HistoryChart> -->
        <div v-if="!currentProbe.id" class="h-100">
          <v-search
            :formContent="formContent"
            :SearchForm="SearchForm"
            @resetFn="resetFn"
            @searchFn="searchFn"
            :inline="true"
          />

          <LineChart
            v-loading="isRenderChart"
            :probe="SearchForm.probe"
            :customUnit ="customUnit"
            ref="lineChart"
          ></LineChart>

          <el-table
            :data="tableData"
            stripe
            v-loading="loading"
            ref="multipleTable"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="headCellStyle"
            height="calc(100% - 450px)"
            :row-style="{ height: '35px' }"
          >
            <el-table-column :label="$t('integration.equipment')" prop="no">
              <template #default="{ row }">
                <AsyncPopover
                  trigger="hover"
                  :cache-key="['appConfig', 'sensor_no']"
                  :request="async () => getProbeDetailRequest(row)"
                  :key="row.collectTime"
                >
                  <template #default="{data,loading}">
                    <div v-loading="loading">
                      <ul>
                        <li>
                          {{ $t('integration.equipment_no') }}:{{
                            data.sensor && data.sensor.tagId
                          }}
                        </li>
                        <li>
                          {{ $t('lang.device_name') }}:{{
                            data.sensor && data.sensor.tagId
                          }}
                        </li>
                        <template
                          v-for="(value, key) in transformCollectInterval(
                            data.appConfig
                          )"
                        >
                          <li :key="key">{{ key }}:{{ value }}</li>
                        </template>
                        <li>
                          {{ $t('integration.describe') }}:{{
                            data.sensor && data.sensor.description
                          }}
                        </li>
                      </ul>
                    </div>
                  </template>

                  <template #reference>
                    <i class="el-icon-info cursor-pointer"></i>
                  </template>
                </AsyncPopover>
                <!--              <i v-icon:theme="['sensorTypeConvert', query.deviceType]"></i>-->
                {{ row.no }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('integration.acquisition_time')"
              prop="collectTime"
            >
              <template #default="{ row }">
                {{ $timetransition(row.collectTime) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('integration.collect_data')" prop="val">
              <template #default="{ row }">
                <span v-range="[row.val, row]">
                  {{  formatTempValue(row.val, customUnit[SearchForm.probe]) }}{{ customUnit[SearchForm.probe] }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('integration.monitoring_interval')"
              prop="min"
            >
              <template #default="{ row }">
                <template v-if="row.min !== undefined">
                  {{ formatTempValue(row.min, customUnit[SearchForm.probe]) }}{{ customUnit[SearchForm.probe] }} ~ {{ formatTempValue(row.max, customUnit[SearchForm.probe])
                  }}{{ customUnit[SearchForm.probe] }}
                </template>
                <template v-else>
                  {{ $t('integration.no_monitoring_interval') }}
                </template>
              </template>
            </el-table-column>
          </el-table>

          <div class="uk-flex uk-flex-right">
            <!--                            <Pagination class="pagination" ref="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"-->
            <!--                                :limit.sync="SearchForm.iDisplayLength" :pageSizes="[5, 20, 50, 100]"-->
            <!--                                :iDisplayLength="SearchForm.iDisplayLength" @pagination="getListFn('async')"></Pagination>-->
            <Pager
              ref="pagination"
              :total="total"
              :size="SearchForm.iDisplayLength"
              @currentChange="currentChange"
            ></Pager>
          </div>
        </div>
        <!--          <div v-show="!echartObj.data.length">-->
        <!--            <el-empty></el-empty>-->
        <!--          </div>-->
      </div>
    </div>
    <!--    <ExportDialog-->
    <!--      :isShow.sync="exportDiaShow"-->
    <!--      :searchForm="eForm"-->
    <!--      ref="dia"-->

    <!--      :comNmae="exportSampleHisotry"-->
    <!--    />-->
    <!--    <ProbeDetail></ProbeDetail>-->
  </div>
</template>

<script>
import FullPath from '@/pages/business/win/ProbeHistory/components/FullPath.vue'
import Pager from '@/components/Pagination/src/Pager.vue'
import ProbeInfo from '@/pages/business/win/TransportHistory/components/ProbeInfo.vue'
import LineChart from '@/components/Charts/LineChart.vue'
import formContent from '@/pages/business/win/ProbeHistory/config/search'
import { downloadImage } from '@/utils/file/download'
import { calcSeries, processToken } from '@/utils/chartDataProcess'
import { probeHisotry } from '@/api/modules/carrier'

import AsyncPopover from '@/components/AsyncPopover/AsyncPopover.vue'
import { transformCollectInterval } from '@/utils/transform/sensorTransForm'
import { getSensorDetail } from '@/api/modules/sensor'
import { defaultUnit } from '@/utils/convert'
import {
  chartOptions,
  markLine
} from '@/components/Charts/schema/LineChartSchema'
import { calcYAxisMinMax } from '@/utils/echart'
import { TempUtils } from '@/utils/TempUtil.js';
import { shareUnit } from '../../../../api/modules/public'
export default {
  created () {
    this.UnitMeasurementFn();
  },
  components: {
    AsyncPopover,
    LineChart,
    ProbeInfo,
    Pager,
    FullPath
  },

  data () {
    return {
      minMax: {
        min: null,
        max: null,
        avg: null,
        ex: null,
        store: null
      },
      total: 0,
      loading: false,
      tableData: [],
      // 表格的监测区间
      range: [],
      echartObj: {
        min: '',
        max: '',
        data: [],
        rangeData: []
      },
      yAxisRange: {
        min: 0,
        max: 0
      },
      formContent: formContent,
      isRenderChart: true,
      SearchForm: {
        code: '',
        carrierId: 0,
        time: '',
        isEx: '',
        isStore: '',
        dataSort: 0,
        pageSort: 1,
        devCatalog: 0,
        block: 1,
        probe: 'temp',
        token: null,
        iDisplayStart: 0,
        iDisplayLength: 5,
        from: undefined,
        to: undefined
      },
      customUnit:{},
    }
  },
  mounted () {
    this.SearchForm.carrierId = this.carrierInfo.carrierId
  },
  methods: {
    UnitMeasurementFn () {
      shareUnit().then(({ result }) => {
        let obj = {};
        result.forEach(item => {
          obj[item.code] = item.name;
        });
        this.customUnit = obj;
      })
    },
    formatTempValue(val,code) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'
      const result = TempUtils.convertToCelsius(numVal, code)
      const finalVal = isNaN(result) ? '--' : Number(result).toFixed(2)
      return `${finalVal}`
    },
    showBuffer (range, status) {
      const options = this.$refs.lineChart.getOption()
      if (status && range && options.series.length) {
        options.series[0].markLine = markLine(range.min, range.max)
      } else {
        options.series[0].markLine = {}
      }
      this.$nextTick(() => {
        this.$refs.lineChart.setOption(options)
      })
    },
    otherProbeChange (compare, code) {
      compare.push(this.$refs.probeInfo.form.code)
      const options = this.$refs.lineChart.getOption()

      // 非选中状态
      if (!code) {
        options.series = options.series.filter(
          // 只保留有的

          item => compare.indexOf(item.code) !== -1
        )

        this.$nextTick(() => {
          this.$refs.lineChart.setOption(options)
        })
        return
      }

      this.SearchForm.code = code
      this.SearchForm.token = null
      this.loading = true

      processToken(probeHisotry, this.SearchForm, result => {
        result.data = result.data.map(item => {
          item.time = item.collectTime
          return item
        })

        const chartOptions = calcSeries(result.data, {}, this.SearchForm.probe)

        if (chartOptions.series.length) {
          chartOptions.series[0].code = code

          options.series.push(chartOptions.series[0])
          this.$nextTick(() => {
            this.$refs.lineChart.setOption(options)
            this.loading = false
          })
        }
      })
    },
    async getProbeDetailRequest (row) {
      const { result } = await getSensorDetail(row.no)
      return {
        data: result
      }
    },
    transformCollectInterval,
    currentChange ({ iDisplayStart, iDisplayLength }) {
      this.SearchForm.code = this.$refs.probeInfo.form.code

      this.SearchForm.iDisplayStart = iDisplayStart
      this.SearchForm.iDisplayLength = iDisplayLength
      this.getListFn()
    },
    probeChange (form) {
      this.minMax.ex = 0
      this.minMax.store = 0
      this.isRenderChart = true
      this.SearchForm = { ...this.SearchForm, ...form }
      this.getListFn()
    },
    async getListFn () {
      const option = await this.getChartOption(this.$refs.probeInfo.form.code)
      const chartOption = chartOptions({
        unit: this.customUnit[this.SearchForm.probe]
      })
      chartOption.yAxis.min = this.yAxisRange.min
      chartOption.yAxis.max = this.yAxisRange.max

      chartOption.series.push(option)
      chartOption.visualMap = []


      this.$refs.lineChart.setOption(chartOption)

      this.$refs.probeInfo.compare.forEach(code => {
        if (!code) {
          return
        }
        this.SearchForm.token = null

        this.getChartOption(code).then(option => {
          chartOption.series.push(option)

          this.$refs.lineChart.setOption(chartOption)
        })
      })
    },
    getChartOption (code) {
      return new Promise((resolve, reject) => {
        this.SearchForm.code = code
        this.SearchForm.from = new Date(this.SearchForm.time[0]).getTime()
        this.SearchForm.to = new Date(this.SearchForm.time[1]).getTime()
        this.loading = true

        processToken(
          probeHisotry,
          JSON.parse(JSON.stringify(this.SearchForm)),
          result => {
            this.minMax.min = TempUtils.convertToCelsius(result.minVal, this.customUnit[this.SearchForm.probe])
            this.minMax.max = TempUtils.convertToCelsius(result.maxVal, this.customUnit[this.SearchForm.probe])
            this.minMax.avg = TempUtils.convertToCelsius(result.avgVal, this.customUnit[this.SearchForm.probe])
            console.log(this.customUnit[this.SearchForm.probe]);
            console.log(this.minMax.min," - ", this.minMax.max);
            const { min, max } = calcYAxisMinMax(result)
            this.yAxisRange.min = TempUtils.convertToCelsius(min, this.customUnit[this.SearchForm.probe])
            this.yAxisRange.max = TempUtils.convertToCelsius(max, this.customUnit[this.SearchForm.probe])

            if (!result.data.length) {
              this.loading = false
              this.isRenderChart = false
              this.tableData = []
              this.$refs.lineChart.setOption({})
              // 如果是主传感器
              if (this.$refs.probeInfo.form.code === this.SearchForm.code) {
                this.$message.warning($t("integration.no_data_temporarily"))
              }
              return
            }

            result.data = result.data.map(item => {
              item.time = item.collectTime
              item.val = TempUtils.convertToCelsius(item.val,this.customUnit[this.SearchForm.probe])
              item.max = !item.max ? '' :TempUtils.convertToCelsius(item.max,this.customUnit[this.SearchForm.probe])
              item.min =  !item.min ? '' : TempUtils.convertToCelsius(item.min,this.customUnit[this.SearchForm.probe])
              if (item.isEx) {
                this.minMax.ex += 1
              }
              if (item.isStore) {
                this.minMax.store += 1
              }
              return item
            })

            if (
              result.dafaultForm &&
              this.SearchForm.code === this.$refs.probeInfo.form.code
            ) {
              this.SearchForm.from = result.dafaultForm
              this.SearchForm.to = result.dafaultTo

              this.SearchForm.time = [
                this.$timetransition(result.dafaultForm),
                this.$timetransition(result.dafaultTo)
              ]

              this.total = result.page.pageInfo.total

              this.tableData = result.page.result
            }

            const options = calcSeries(result.data, {}, this.probe)

            if (options.series.length) {
              // options.series[0].code = this.currentProbe.code
              options.series[0].code = code
              resolve(options.series[0])
            }

            if (this.isRenderChart) {
              // this.$refs.lineChart.setOption(options)

              this.isRenderChart = false
            }
            this.loading = false
          }
        )
      })
    },
    searchFn () {
      this.isRenderChart = true
      this.SearchForm.token = ''
      this.SearchForm.iDisplayStart = 0
      this.$refs.pagination.reset()

      this.getListFn('search')
    },
    resetFn () {
      this.isRenderChart = true
      this.SearchForm.time = ''
      this.SearchForm.isEx = ''
      this.SearchForm.isStore = ''
      this.SearchForm.from = ''
      this.SearchForm.to = ''
      this.SearchForm.token = ''
      this.SearchForm.iDisplayStart = 0
      this.SearchForm.iDisplayLength = 5
      this.echartObj = {
        min: '',
        max: '',
        data: [],
        rangeData: []
      }
      this.$refs.pagination.reset()
      this.getListFn('sync')
    },
    onFullPath (fullPath) {
      document.title = fullPath + $t('integration.chart')
    },
    downLoad () {
      const { carrierName } = this.$route.query
      const { time } = this.SearchForm
      const base64 = this.$refs.chart.getChart()
      downloadImage(
        base64,
        `[${carrierName}]_${$t('integration.sample_historical_line_chart')}_F[${time[0]}]_T[${time[1]}]`
      )
    },
    unitChange (name) {
      this.unitArray.forEach(item => {
        if (name === item.key) {
          this.unitObj = item
        }
      })
      this.SearchForm.probe = name
      // this.token = null;
      this.count = 0
      this.SearchForm.min = undefined
      this.SearchForm.max = undefined
      this.SearchForm.token = ''
      this.range = []
      this.resetFn()
      // this.getListFn('search');
    },
    getCurrentProbe () {
      return this.$refs.probeInfo.currentProbe
    }
  },
  computed: {
    defaultUnit () {
      return defaultUnit
    },
    probe () {
      return this.$refs.probeInfo && this.$refs.probeInfo.form.probe
    },
    carrierInfo () {
      const { carrierId, type, carrierType, carrierName } = this.$route.query

      return {
        carrierId,
        carrierType: type || carrierType,
        carrierName
      }
    },
    currentProbe () {
      return (this.$refs.probeInfo && this.$refs.probeInfo.currentProbe) || {}
    },

    timeRange () {
      return {
        start: this.SearchForm.time[0],
        end: this.SearchForm.time[1]
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
